import PropTypes from 'prop-types';

const ResponsiveSurface = ({ isDesktop, DesktopComponent, MobileComponent, desktopProps = {}, mobileProps = {}, ...commonProps }) => {
  const Component = isDesktop ? DesktopComponent : MobileComponent;
  const specificProps = isDesktop ? desktopProps : mobileProps;
  return <Component {...commonProps} {...specificProps} />;
};

ResponsiveSurface.propTypes = {
  isDesktop: PropTypes.bool,
  DesktopComponent: PropTypes.elementType.isRequired,
  MobileComponent: PropTypes.elementType.isRequired,
  desktopProps: PropTypes.object,
  mobileProps: PropTypes.object,
};

export default ResponsiveSurface;
